import React from "react";

import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function CalculatedDistanceDetails({ label, distance }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={distance}
            />
        </EuiFlexItem>
    );
}
